<div class="flex flex-col bg-white rounded-xl w-213 h-208.5">
  <div class="flex items-start justify-between">
    @if (isConfirmMode) {
      <div class="px-14 pt-16 pb-4 flex-1">
        <h2 class="text-[24px] font-bold text-th-blue-highlight-2">{{ data.title }}</h2>
        @if (data.description) {
          <p class="text-[16px] font-medium text-th-black mt-4 whitespace-pre-line">
            {{ data.description }}
          </p>
        }
      </div>
    } @else {
      <div class="flex-1"></div>
    }
    <button mat-icon-button mat-dialog-close class="shrink-0 mt-2 mr-2 mb-2">
      <mat-icon svgIcon="close-icon" class="w-6! h-6! text-[24px]! text-[#0C2447]!"></mat-icon>
    </button>
  </div>

  <div
    class="flex-1 overflow-y-auto pl-15 pr-7 mr-5.75 [&::-webkit-scrollbar]:w-2.25 [&::-webkit-scrollbar-track]:bg-[#D9D9D9] [&::-webkit-scrollbar-track]:rounded-full [&::-webkit-scrollbar-thumb]:bg-th-blue-highlight-2 [&::-webkit-scrollbar-thumb]:rounded-full"
  >
    @if (isLoading()) {
      <div class="flex items-center justify-center py-16">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    } @else {
      @for (page of pdfPages(); track $index) {
        <img
          [src]="page.imageUrl"
          class="w-full"
          [ngClass]="{ 'border-b border-th-gray': !$last }"
          alt="Página {{ $index + 1 }}"
        />
      }
    }
  </div>

  @if (!isLoading()) {
    @if (isConfirmMode) {
      <div class="flex justify-center gap-4 p-6">
        <button
          (click)="cancel()"
          class="w-46.25 h-12 flex items-center justify-center text-[16px] font-bold border border-th-blue text-th-blue rounded-[3px] cursor-pointer hover:opacity-90 transition-opacity"
        >
          Cancelar
        </button>
        <button
          (click)="confirm()"
          class="w-46.25 h-12 flex items-center justify-center text-[16px] font-bold bg-th-blue text-white rounded-[3px] cursor-pointer hover:opacity-90 transition-opacity"
        >
          Continuar
        </button>
      </div>
    } @else {
      <div class="flex justify-center gap-4 p-6">
        <button
          (click)="downloadPdf()"
          class="w-46.25 h-12 flex items-center justify-center gap-3 text-[16px] font-bold bg-th-blue text-white rounded-[3px] cursor-pointer hover:opacity-90 transition-opacity"
        >
          <mat-icon svgIcon="download-icon"></mat-icon>
          Descargar
        </button>
      </div>
    }
  }
</div>
